import { Form, Modal } from 'antd';
import React from 'react';
import classes from './GenerateFileModal.module.scss';
import { getTheme } from 'helpers/getTheme';
import cn from 'classnames';
import { useAppDispatch } from 'store/hook';
import { setIsFileCreateOpen } from 'store/slices/dataRoomSlice';
import { useTranslation } from 'react-i18next';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import CreatingFile from './components/CreatingFile';

type GenerateFileModalProps = {
  open: boolean;
}

const GenerateFileModal = ({ open }: GenerateFileModalProps) => {
  const [checking, setChecking] = React.useState(false);
  
  const [currentSegment, setCurrentSegment] = React.useState('creating');
  const [isFileCreating, setIsFileCreating] = React.useState<boolean>(false);
  const [readyDocument, setReadyDocument] = React.useState<any>({id: '', name: '', format: ''});
  
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const onCancelClick = () => {
    dispatch(setIsFileCreateOpen(false));
  };

  const clearResponse = () => setReadyDocument({id: '', name: '', format: ''});

  const segmentOptions = [
    {value: 'creating', label: t('Documents.modals.createFile.segments.creating')},
    {value: 'history', label: t('Documents.modals.createFile.segments.history')},
  ];

  const content = {
    creating: (
      <CreatingFile
        form={form}
        readyDocument={readyDocument}
        setReadyDocument={setReadyDocument}
        isFileCreating={isFileCreating}
        setIsFileCreating={setIsFileCreating}
        onCancelClick={onCancelClick}
        setChecking={setChecking}
        checking={checking}
      />
    ),
    history: (
      <div>history</div>
    )
  }

  return (
    <Modal
      title={t('Documents.modals.createFile.title')}
      okText={readyDocument?.id ? t('Documents.modals.createFile.retry') : t('Documents.modals.createFile.create')}
      // cancelText
      width={450}
      style={{ top: 160 }}
      open={open}
      onCancel={onCancelClick}
      onOk={readyDocument?.id ? clearResponse : form.submit}
      className={cn(
        classes.createModal,
        getTheme(),
      )}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{
        disabled: isFileCreating || checking,
        loading: checking,
        type: readyDocument?.id ? 'default' : 'primary',
        style: {display: currentSegment !== 'creating' ? 'none' : 'block'}
      }}
    >
      {/* <Segmented
        className={classes.segmentSwitch}
        options={segmentOptions}
        block
        value={currentSegment}
        onChange={(value) => setCurrentSegment(value)}
      />

      {content[currentSegment as keyof typeof content]} */}

      <CreatingFile
        form={form}
        readyDocument={readyDocument}
        setReadyDocument={setReadyDocument}
        isFileCreating={isFileCreating}
        setIsFileCreating={setIsFileCreating}
        onCancelClick={onCancelClick}
        setChecking={setChecking}
        checking={checking}
      />

      {isFileCreating && <UploadingComponent />}
    </Modal>
  );
}

export default GenerateFileModal;
